import React, { useState } from "react";
import { useEffect } from "react";
import { Container, ContainerView } from "../../components/Container";
import { TitlePage, TitleStake } from "../../components/Layout";
import {
  BlockInfoWallet,
  HeaderTableStake,
  Separation,
  StakingOrderContainer,
  StakingProduct,
  StatusStakingProduct,
  TextAddress,
  TextItemDetail,
  TextItemDetail3,
  TitleTextFiter,
} from "./style";
import { LoadingOutlined } from "@ant-design/icons";
import { SGTIcon } from "../../components/Icons/SGTIcon";
import { RecordNotFound } from "../../components/RecordNotFound";
import { useWindowSize } from "../../hook/useWindowSize";
import { StakeOrderItem } from "./components/StakeOrderItem";
import { ModalFilter } from "./components/ModalFilter";
import ScreenConnectWallet from "./components/ScreenConnectWallet";
import { useApp } from "../../contexts";

import { useNavigate } from "react-router-dom";
import { MyButton } from "../../components/Button/style";
import {
  convertDataStake,
  convertHexBalanceToDecimal,
  formatMoney,
} from "../../utils/hepler";
import ModalConnectWallet from "./components/ModalConnectWallet";
import ModalDetailStake from "./components/ModalDetailStake";
import { Col, Row } from "antd";
import Footer from "../../components/Layout/footer";
import FormButton from "../../components/FormCustom2/Button";

const Stake = () => {
  const navigate = useNavigate();
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const { addressConnected, web3Provider, masterContract, T } = useApp();
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [stakes, setStakes] = useState([]);
  const [balanceSGT, setBalanceSGT] = useState(0);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [dataViewStakeDetail, setDataViewStakeDetail] = useState(null);
  const [isGettingBalance, setIsGettingBalance] = useState(false);

  useEffect(() => {
    if (!addressConnected) return;
    if (!masterContract) return;
    if (!web3Provider) return;
    (async () => {
      try {
        setIsGettingBalance(true);
        const balance = await masterContract.sgtContract.balanceOf(
          addressConnected
        );
        const decimailsSGTContract =
          await masterContract.sgtContract.decimals();
        setBalanceSGT(
          formatMoney(convertHexBalanceToDecimal(balance, decimailsSGTContract))
        );
        setIsGettingBalance(false);
      } catch (error) {
        setIsGettingBalance(false);
      }
    })();
  }, [addressConnected, web3Provider, masterContract]);

  useEffect(() => {
    if (!masterContract) return;
    if (!web3Provider) return;
    if (!addressConnected) return;
    if (!masterContract.sgtStakingContract) return;
    const getStakes = async () => {
      const stakes = await masterContract.sgtStakingContract
        .connect(web3Provider.getSigner())
        .getStakes();
      setStakes(stakes?.map((item) => convertDataStake(item)));
    };
    getStakes();
  }, [addressConnected, web3Provider, masterContract]);

  const handleOpenModalFilter = () => {
    setIsOpenFilter(true);
  };

  const onClickViewDetailItem = (item) => {
    setDataViewStakeDetail(item);
  };

  const onCloseViewDetailItem = () => {
    setDataViewStakeDetail(null);
  };

  const handleClaim = async (id) => {
    try {
      const res = await masterContract.sgtStakingContract
        ?.connect(web3Provider.getSigner())
        ?.unstake(id);
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };
  return !addressConnected ? (
    <ScreenConnectWallet />
  ) : (
    <Container>
      <ContainerView>
        <TitleStake className="lg:mt-14 mt-[25px]">{T("Stake")}</TitleStake>
        <div className="flex justify-between items-center">
          <TitlePage className="lg:mt-[47px] mt-[26px]">
            {T("Staking Products")}
          </TitlePage>
        </div>

        <StakingProduct className="mt-[20px] lg:mt-[30px] relative">
          <div
            className=" cursor-pointer"
            onClick={() => navigate("/stake-detail")}
          >
            <div className="flex gap-[13px] items-center lg:pb-[17px] pb-[18px]">
              <SGTIcon
                width={!isMobile ? 32 : 28}
                height={!isMobile ? 32 : 28}
              />
              <span className=" font-semibold text-[16px] lg:text-[18px] leading-6 text-[#000000]">
                {T("Stake SGT")}
              </span>
            </div>
            <div className="flex justify-between gap-[14px] border-t-[1px] pt-1 h-[auto]">
              <TextItemDetail> {T("Earn xSGT")}</TextItemDetail>
              <TextItemDetail>{T("0.5 to 5 voting power/SGT")}</TextItemDetail>
              <TextItemDetail> {T("0.5 to 5 years")}</TextItemDetail>
            </div>
          </div>
        </StakingProduct>
        <BlockInfoWallet className="mt-[20px] lg:mt-[30px]">
          <div className="flex flex-wrap items-center gap-x-[50px]">
            <div className="flex flex-nowrap items-center ">
              <TextItemDetail className="whitespace-nowrap !text-[#707070]">
                {T("Wallet Address")}:
              </TextItemDetail>
              <TextAddress className="!font-bold ml-1 !text-[#707070]">
                {addressConnected}
              </TextAddress>
            </div>
            <Separation className="hidden lg:block !text-[#707070]" />
            <div className="flex flex-nowrap items-center ">
              <TextItemDetail className="!text-[#707070]">
                {T("Available SGT balance")}:
              </TextItemDetail>
              {isGettingBalance ? (
                <LoadingOutlined />
              ) : (
                <TextItemDetail className="!font-bold ml-1 !text-[#707070]">
                  {balanceSGT} SGT
                </TextItemDetail>
              )}
            </div>
          </div>
          <FormButton
            width={isMobile ? 300 : 120}
            className="primary2 mt-[25px] ml-[50%] lg:mt-0 translate-x-[-50%] lg:translate-x-0 lg:ml-0"
            onClick={() => setIsVisibleModal(true)}
          >
            {T("title.change")}
          </FormButton>
        </BlockInfoWallet>
        <div className="mt-[44px] lg:mt-[57px]">
          <div className="flex justify-between items-center">
            <TitlePage>{T("Staking Orders")}</TitlePage>
          </div>
          <div className="mt-[21px] lg:mt-[30px]">
            {!stakes.length ? (
              <div>
                <RecordNotFound />
              </div>
            ) : (
              <>
                <HeaderTableStake gap={20} className="hidden lg:flex h-[34px]">
                  <Col span={1}></Col>
                  <Col
                    span={7}
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                  >
                    {T("Token")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                    span={6}
                  >
                    {T("Amount")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] text-center"
                    span={4}
                  >
                    {T("Duration")}
                  </Col>
                  <Col
                    className="font-semibold text-[16px] leading-[17px] text-[#000000] justify-end pr-[30px]"
                    span={6}
                  >
                    {T("Status")}
                  </Col>
                </HeaderTableStake>
                <StakingOrderContainer>
                  {stakes?.map((stake, index) => (
                    <StakeOrderItem
                      onClick={onClickViewDetailItem}
                      onClaim={handleClaim}
                      item={stake}
                      key={index}
                      isborder={index === stakes.length - 1 ? "false" : "true"}
                    />
                  ))}
                </StakingOrderContainer>
              </>
            )}
          </div>
        </div>
      </ContainerView>
      {dataViewStakeDetail && (
        <ModalDetailStake
          onBack={onCloseViewDetailItem}
          onClose={onCloseViewDetailItem}
          data={dataViewStakeDetail}
        />
      )}
      {isVisibleModal && (
        <ModalConnectWallet onClose={() => setIsVisibleModal(false)} />
      )}
      {isOpenFilter && (
        <ModalFilter
          isVisible={isOpenFilter}
          onClose={() => setIsOpenFilter(false)}
        />
      )}
    </Container>
  );
};

export default Stake;
